import type { Monaco } from "@monaco-editor/react"
import projectSettingsSchema from "@/schemas/project-settings.schema.json"
import {
  PROJECT_SETTINGS_FILENAME,
  PROJECT_SETTINGS_SCHEMA_ID,
} from "@/lib/project-settings"

/**
 * Register the canonical Project Settings schema with Monaco's JSON language
 * service so `project.rudra.config.json` gets hover hints, autocomplete, and
 * validation from that single schema.
 */
export function registerProjectSettingsJsonSchema(monaco: Monaco): void {
  if (!monaco.languages.json) return

  const jsonDefaults = monaco.languages.json.jsonDefaults
  const current = jsonDefaults.diagnosticsOptions
  const schemas = [...(current.schemas ?? [])]
  if (schemas.some((entry) => entry.uri === PROJECT_SETTINGS_SCHEMA_ID)) return

  schemas.push({
    uri: PROJECT_SETTINGS_SCHEMA_ID,
    fileMatch: [
      PROJECT_SETTINGS_FILENAME,
      `**/${PROJECT_SETTINGS_FILENAME}`,
      `*/${PROJECT_SETTINGS_FILENAME}`,
    ],
    schema: projectSettingsSchema,
  })

  jsonDefaults.setDiagnosticsOptions({
    ...current,
    validate: true,
    allowComments: false,
    schemas,
  })
}
